// src/components/UpdateBanner.jsx
// Shows a non-intrusive banner when a new deployment is detected.
// Auto-dismisses after 30s. Reload button applies the update immediately.
// Does NOT interrupt active payment flows.

import React, { useEffect, useState } from 'react';

const UpdateBanner = ({ version, onApply, onDismiss }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 30000);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="alert"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[99998] flex items-center gap-3 bg-[#0057B7] text-white text-sm font-medium px-4 py-3 rounded-xl shadow-xl max-w-sm w-[calc(100%-2rem)]"
      style={{ animation: 'slideUp 0.3s ease-out' }}
    >
      <span className="flex-1">
        ✨ New version available{version ? ` (v${version})` : ''}
      </span>
      <button
        onClick={() => { setVisible(false); onApply?.(); }}
        className="bg-white text-[#0057B7] text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-blue-50 transition-colors flex-shrink-0"
      >
        Update
      </button>
      <button
        onClick={() => { setVisible(false); onDismiss?.(); }}
        className="text-white/70 hover:text-white text-lg leading-none flex-shrink-0"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default UpdateBanner;
